import React from 'react';
import { connect } from "react-redux";

// @material-ui/core
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

// core components
import CoursesTaught from './CoursesTaught/CoursesTaught';
import CardsCoursesInProgress from "./CoursesInProgress/CardsCoursesInProgress";
import ProgramsInProgress from "./ProgramsInProgress/ProgramsInProgress";
import CoursesCompleted from './CoursesCompleted/CoursesCompleted';
import SavedCourses from './SavedCourses/SavedCourses';
import RecommendedCourseMyClass from './RecommendedCourses/RecommendedCourseMyClass';

import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { useHistory } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { hasInstructorPermission } from '../../services/UserService';


import { log } from '../../shared/utils/console.js'

// Material Functions
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { eventTracker, eventData } from '../../shared/components/EventTracker/EventTracker';
import InformativeBanner from '../../design-system/components/Banners/InformativeBanner.jsx';
import WarningBanner from '../../design-system/components/Banners/WarningBanner.jsx';

// SDK
import { RecordDocumentService, UserService } from '@sdk-point/talisis';
import { Link, Typography } from '@material-ui/core';
import CoursesProvider from '../../shared/components/CourseCarousel/context/CoursesProvider.jsx';
import AddCurp from './components/AddCurp.jsx';
import SearchLibrary from './components/searchLibrary';

import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react';
import { isMantenance } from '../../shared/constants/maintenance';


const RecordDocumentServiceSDK = new RecordDocumentService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
const UserServiceSDK = new UserService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

let tabs = [
    { value: 'Mis Programas', uuid: uuid() },
    { value: 'Mis Cursos', uuid: uuid() },
    { value: 'Guardados', uuid: uuid() },
    { value: 'Completados', uuid: uuid() },
    { value: 'Recomendados', uuid: uuid() },
];

const useStyles = makeStyles((theme) => ({
    tabMain: {
        overflow: "visible",
        borderBottom: "none",
        paddingLeft: "62px",
        marginBottom: "0px",
        flex: 1,
        minWidth: 0,
        '& .MuiTabs-flexContainer': {
            borderBottom: "none",
        },
        '& .MuiTabs-scroller': {
            marginLeft: "24px",
        },
        "@media (max-width: 1250px)": {
            '& .MuiTabs-flexContainer': {
                minWidth: "max-content",
            }
        },
        "@media (max-width: 740px)": {
            paddingLeft: "15px",
            paddingRight: "15px",
        },
    },
    mainCenter: {
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid #828D9E",
        [theme.breakpoints.down('sm')]: {
            flexWrap: "wrap",
        },
    },
    mainCarousels: {
        width: "100%",
        boxSizing: "border-box",
        position: "absolute",
        left: "0px",
        top: "185px",
        paddingLeft: "0px",
        paddingRight: "0px",
        overflow: "hidden",
        maxWidth: "100vw",
    },
    mainCarousels_2: {
        width: "100%",
        boxSizing: "border-box",
        paddingTop: "25px",
        overflow: "hidden",
        maxWidth: "100vw",
        "@media (max-width: 425px)": {
            marginTop: '100px'
        },
    },
    tabs: {
        textTransform: "capitalize",
        [theme.breakpoints.down('xs')]:{
            fontSize: '15px'
        }
    },
    searchContainer: {
        width: '400px',
        flexShrink: 0,
        paddingRight: '32px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: '8px 16px',
            boxSizing: 'border-box',
        },
    },
}));

const Coursesv2 = ({ user }) => {
    const isResponsive = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const [maintenance, setMaintenance] = React.useState({show: false, message: '', title: ''})
    const [value, setValue] = React.useState(0);
    const [tabCatalogCoursesTaught, setTabCatalogCoursesTaught] = React.useState(false);
    const [tabCatalogAllCourses, setTabCatalogAllCourses] = React.useState(true);
    const [tabCoursesInProgress, setTabCoursesInProgress] = React.useState(false);
    const [tabProgramsInProgress, setTabProgramsInProgress] = React.useState(false);
    const [tabCoursesCompleted, setTabCoursesCompleted] = React.useState(false);
    const [tabSavedCourses, setTabSavedCourses] = React.useState(false);
    const [hasRejectedDocuments, setHasRejectedDocuments] = React.useState(false);

    const history = useHistory();
    const classes = useStyles({isResponsive});
    const [personData, setPersonData] = React.useState({activateCurp: null})

    const instructorPermission = hasInstructorPermission();
    const maintenanceIsOn = useFeatureIsOn('maintenance-courses')
    const maintenanceValue =  useFeatureValue('maintenance-courses')

    React.useEffect(() => {
        if(maintenanceIsOn && maintenanceValue?.is_support){
            const titleText = isResponsive ? maintenanceValue.title.textResponsive : maintenanceValue.title.text;
            // Convertir string con HTML a elemento React si contiene <br/>
            const titleElement = typeof titleText === 'string' && titleText.includes('<br/>')
                ? <span dangerouslySetInnerHTML={{ __html: titleText }} />
                : titleText;
            setMaintenance({show: isMantenance(maintenanceValue), title: titleElement, message: maintenanceValue.description})
        }
    }, [maintenanceIsOn, maintenanceValue, isResponsive])
    React.useEffect(() => {
        if(user.person_id){
            getUserData();
        }
    }, [user])

    const getUserData = async() => {
        try {
            const response = await UserServiceSDK.getData(user.person_id);
            if(response.user){
                setPersonData(response.user)
            }
        } catch (error) {

        }
    }

    // Instructor tiene tab extra "Mis Materias" al inicio
    if (instructorPermission) {
        tabs = [
            { value: 'Mis Materias', uuid: uuid() },
            { value: 'Mis Programas', uuid: uuid() },
            { value: 'Mis Cursos', uuid: uuid() },
            { value: 'Guardados', uuid: uuid() },
            { value: 'Completados', uuid: uuid() },
            { value: 'Recomendados', uuid: uuid() },
        ];
    }

    // Offset: instructor tiene "Mis Materias" en index 0, desplaza los demás +1
    const tabOffset = instructorPermission ? 1 : 0;

    const handleChange = (event, newValue) => {
        event.preventDefault();

        if (instructorPermission && newValue === 0) {
            handleChangeTabTaught(event);
        } else if (newValue === tabOffset + 0) {
            handleChangeTabProgramInProgress(event);
        } else if (newValue === tabOffset + 1) {
            handleChangeTabInProgress(event);
        } else if (newValue === tabOffset + 2) {
            handleChangeTabSaved();
        } else if (newValue === tabOffset + 3) {
            handleChangeTabCompleted();
        } else if (newValue === tabOffset + 4) {
            handleChangeTabRecomendados();
        }

        setValue(newValue);
    };

    const handleChangeTabTaught = (e) => {
        e.preventDefault();
        history.push('/cursos?target=mis-materias');
        setTabCatalogCoursesTaught(true);
        setValue(0);
    };

    const handleChangeTabProgramInProgress = (e) => {
        eventTracker('s_clases_progreso', eventData, ['mixpanel']);
        e.preventDefault();
        history.push('/cursos?target=mis-programas');
        setTabProgramsInProgress(true);
        setValue(tabOffset + 0);
    };

    const handleChangeTabInProgress = (e) => {
        eventTracker('s_clases_progreso', eventData, ['mixpanel']);
        e.preventDefault();
        history.push('/cursos?target=mis-cursos');
        setTabCoursesInProgress(true);
        setValue(tabOffset + 1);
    };

    const handleChangeTabSaved = () => {
        eventTracker('s_clases_guardados', eventData, ['mixpanel']);
        history.push('/cursos?target=guardados');
        setTabSavedCourses(true);
        setValue(tabOffset + 2);
    };

    const handleChangeTabCompleted = () => {
        eventTracker('s_clases_completados', eventData, ['mixpanel']);
        history.push('/cursos?target=completados');
        setTabCoursesCompleted(true);
        setValue(tabOffset + 3);
    };

    const handleChangeTabRecomendados = () => {
        eventTracker('s_clases_recomendados', eventData, ['mixpanel']);
        history.push('/cursos?target=recomendados');
        setTabCatalogAllCourses(true);
        setValue(tabOffset + 4);
    };

    const handleClickRedirectBanner = () => {
        history.push("/profile?tab=2");
    };

    const getData = async () => {
        try {
            const queryParams = new URLSearchParams(window.location.search);
            const target = await queryParams.get('target');
            return target;
        }
        catch (e) {
            log(e.message);
        }
    };

    React.useEffect(() => {
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        }
        
        let isCanceled = true;

        const validateRejectedDocument = async () => {
            try {
                const response = await RecordDocumentServiceSDK.getDocumentsByStatus({personId: user.person_id, status: [3, 6]});

                if (!!isCanceled && !!response.success) {
                    setHasRejectedDocuments(!!response.data.documents.length);
                }
            } catch (error) {
            }
        };

        getData()
            .then((target) => {
                if (isCanceled) {
                    if (target === 'mis-materias' && instructorPermission) {
                        setTabCatalogCoursesTaught(true);
                        setValue(0);
                    } else if (target === "mis-programas") {
                        setTabProgramsInProgress(true);
                        setValue(tabOffset + 0);
                    } else if (target === "mis-cursos") {
                        setTabCoursesInProgress(true);
                        setValue(tabOffset + 1);
                    } else if (target === "guardados") {
                        setTabSavedCourses(true);
                        setValue(tabOffset + 2);
                    } else if (target === "completados") {
                        setTabCoursesCompleted(true);
                        setValue(tabOffset + 3);
                    } else if (target === "recomendados") {
                        setTabCatalogAllCourses(true);
                        setValue(tabOffset + 4);
                    } else {
                        // Default: Mis Materias para instructor, Mis Programas para estudiante
                        if (instructorPermission) {
                            setTabCatalogCoursesTaught(true);
                            setValue(0);
                        } else {
                            setTabProgramsInProgress(true);
                            setValue(0);
                        }
                    }
                }
            })
            .catch((err) => {
                log(`Failed: ${err}`);
            });

        validateRejectedDocument();
        return () => (isCanceled = false);
    }, []);

    const hanldeUpdateCurpSuccessful = () => {
        setPersonData({
            ...personData,
            activateCurp: false
        })
    }

    return (
        <CoursesProvider>
            <AddCurp person={personData} updateCurpSuccessful={hanldeUpdateCurpSuccessful}/>
            {maintenance.show && <InformativeBanner
                image='themeCodigo'
                title={maintenance.title}
                text={maintenance.message}
            />}
            {
                !!hasRejectedDocuments &&
                <WarningBanner
                    title='Tienes uno o más documentos rechazados'
                    text={
                        <Typography variant='body2'>
                            Lamentamos informarte que cuentas con uno o más documentos que han sido rechazados por nuestro equipo de Escolar. Para continuar con tu proceso de inscripción, por favor vuelve a cargar los documentos corregidos en nuestro sistema,&nbsp;
                            <Link underline="always" color='secondary' component="button" variant="body2"
                                onClick={handleClickRedirectBanner}
                            >
                                Haciendo clic aquí.
                            </Link>
                        </Typography>
                    }
                    />
            }
            <Box width="100%" style={{ overflowX: "hidden" }}>
                <Box className={classes.mainCenter}>
                    <Tabs className={classes.tabMain} variant="scrollable" scrollButtons="auto" value={value} onChange={handleChange} aria-label="scrollable auto tabs example" indicatorColor="primary">
                        {
                            tabs.map((tab, index) => <Tab className={classes.tabs} key={tab.uuid} label={tab.value} {...a11yProps(index)} />)
                        }
                    </Tabs>
                    <Box className={classes.searchContainer}>
                        <SearchLibrary />
                    </Box>
                </Box>
                <Box className={classes.mainCarousels_2}>
                    {instructorPermission && tabCatalogCoursesTaught && value === 0 && <Box>
                        <CoursesTaught />
                    </Box>}
                    {tabProgramsInProgress && value === (tabOffset + 0) && <Box>
                        <ProgramsInProgress />
                    </Box>}
                    {tabCoursesInProgress && value === (tabOffset + 1) && <Box>
                        <CardsCoursesInProgress />
                    </Box>}
                    {tabSavedCourses && value === (tabOffset + 2) && <Box>
                        <SavedCourses isMyCourses={true} />
                    </Box>}
                    {tabCoursesCompleted && value === (tabOffset + 3) && <Box>
                        <CoursesCompleted />
                    </Box>}
                    {tabCatalogAllCourses && value === (tabOffset + 4) && <Box>
                        <RecommendedCourseMyClass handleChangeTabSaved={handleChangeTabSaved} handleChangeTabInProgress={handleChangeTabInProgress} />
                    </Box>}
                </Box>
            </Box>
        </CoursesProvider>
    );
};

const mapStateToProps = (reducers) => reducers.userReducer;
export default connect(mapStateToProps, {})(Coursesv2);